<template>
	<div class="box">
		<div class="header">
			<div class="logo pointer" @click="return_">
				<img src="../../static/images/logo.png" alt="">
			</div>
			<div class="header_right">
				<img @click="return_" src="../../static/images/brand/guanbi.png" alt="">
			</div>
		</div>
		<div class="topkongbox"></div>
		<div class="main" :style="{ 'min-height': screenHeight + 'px' }">
			<div class="mainkongbox"></div>
			<h1>{{$t('m.register_01')}}</h1>
			<div class="zhuce">
				<div class="text1">{{$t('m.register_02')}}?</div>
				<div class="orange pointer" @click="login">&nbsp;&nbsp;{{$t('m.login_01')}}</div>
			</div>

			<!-- <div></div> -->
			<div :class="lang==1?'loginbox loginbox1':'loginbox'">
				<div class="inp_item">
					<div class="inp_text">{{$t('m.userinfo_13')}}</div>
					<div class="inp_radio" v-for="(item, index) in radio_list" :key="index" @click="chang_radio(index)">
						<div class="radio pointer">
							<img v-show="item.Selected" src="../../static/xuanzhong.png" alt="">
							<img v-show="!item.Selected" src="../../static/weixuanzhong.png" alt="">
							<span>{{ item.text }}</span>
						</div>
					</div>
				</div>
				
				<div class="inp_item">
					<div class="inp_text">{{$t('m.userinfo_133')}}</div>
					<div class="inp_radio" @click="is_yx = true">
						<div class="radio pointer">
							<img v-show="is_yx==true" src="../../static/xuanzhong.png" alt="">
							<img v-show="is_yx==false" src="../../static/weixuanzhong.png" alt="">
							<span>{{$t('m.userinfo_134')}}</span>
						</div>
					</div>
					<div class="inp_radio" @click="is_yx = false">
						<div class="radio pointer">
							<img v-show="is_yx==false" src="../../static/xuanzhong.png" alt="">
							<img v-show="is_yx==true" src="../../static/weixuanzhong.png" alt="">
							<span>{{$t('m.userinfo_135')}}</span>
						</div>
					</div>
				</div>
				<!-- 邮箱 -->
				<template v-if="is_yx">
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.register_03')}}：</div>
					<div class="inp_"><input :placeholder="$t('m.register_08')" v-model="param.email"></div>
				</div>
				<!-- 验证码 -->
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.register_04')}}：</div>
					<div class="inp_" style="width: 100%;">
						<input class="yzm" style="width: 100%!important;" v-model="param.email_code" :placeholder="$t('m.register_09')">
					</div>
					<div class="btn pointer" @click="getcode" v-if="!if_send">{{$t('m.register_06')}}</div>
					<div v-if="if_send" class="code_style">{{ code_time }}</div>
				</div>
				</template>
				
				<!-- 电话 -->
				<template v-if="!is_yx">
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.home_13')}}:</div>
					<div class="inp_"><input :placeholder="$t('m.userinfo_18')" v-model="param.mobile"></div>
				</div>
				<!-- 验证码 -->
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.register_04')}}：</div>
					<div class="inp_" style="width: 100%;">
						<input class="yzm" style="width: 100%!important;" v-model="param.mobile_code" :placeholder="$t('m.register_09')">
					</div>
					<div class="btn pointer" @click="getcode_mobile" v-if="!if_send">{{$t('m.register_06')}}</div>
					<div v-if="if_send" class="code_style">{{ code_time }}</div>
				</div>
				</template>
				<!-- 密码 -->
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.login_05')}}：</div>
					<div class="inp_"><input :placeholder="$t('m.login_10')" type="password" v-model="param.password">
					</div>
				</div>
				<!-- 再次输入密码 -->
				<div class="inp_item" v-if="!other_id">
					<div class="inp_text">{{$t('m.register_05')}}：</div>
					<div class="inp_"><input :placeholder="$t('m.register_10')" type="password" v-model="param.password2"></div>
				</div>
				<template v-if="is_yx">
				<div class="inp_item" v-if="type==1">
					<div class="inp_text">{{$t('m.home_13')}}:</div>
					<div class="inp_"><input :placeholder="$t('m.userinfo_18')" v-model="param.phone"></div>
				</div>
				</template>
				<!-- 公司部分 -->
				<div class="inp_item" v-show="type == 2">
					<div class="inp_text">{{$t('m.userinfo_04')}}</div>
					<div class="inp_"><input v-model="param.company_name" :placeholder="$t('m.userinfo_19')"></div>
				</div>
				<div class="inp_item" v-show="type == 2">
					<div class="inp_text">{{$t('m.userinfo_05')}}</div>
					<div class="inp_"><input :placeholder="$t('m.userinfo_20')" v-model="param.company_number"></div>
				</div>
				<div class="upload_item" v-show="type == 2">
					<p>{{$t('m.register_07')}}</p>
					<div class="upload_box">
						<div class="upimg">
							<img class="yyzhimg" v-if="param.company_img"
								:src="this.$common.baseUrl + param.company_img" alt="">
							<div class="boxn" v-if="!param.company_img">
								<img src="../../static/images/shanghcuan.png" alt="">
								<span>{{$t('m.userinfo_12')}}</span>
							</div>
							<label class="iptimg" for="iptimg">
								<input ref="input" @change="updatarequest($event)" id="iptimg" type="file"
									accept="image/*">
							</label>
						</div>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="this.$common.baseUrl + param.company_img" alt="">
						</el-dialog>
					</div>
				</div>
				<!-- 按钮 -->
				<div class="btnbox" @click="confirm">
					<el-button type="danger">{{$t('m.register_01')}}</el-button>
				</div>
			</div>




			<div class="agreement">
				* {{$t('m.login_11')}}
				<div class="orange pointer" @click="dialogVisible1 = true">{{$t('m.login_12')}}</div>
				，{{$t('m.login_13')}}
				<div class="pointer orange" @click="dialogVisible2 = true">
					{{$t('m.login_14')}}
				</div>
			</div>
			<div class="foot_kongbox"></div>
		</div>
		<el-dialog :visible.sync="dialogVisible1" width="50%" @open="terms_of_use">
			<div class="show_title">
				{{content_tltle}}
			</div>
			<div class="tiaokuan" v-html="content"></div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible2" width="50%" @open="privacy_policy">
			<div class="show_title">
				{{content_tltle1}}
			</div>
			<div class="tiaokuan" v-html="content1"></div>
		</el-dialog>
	</div>
</template>
<script>
	import Cookies from 'js-cookie'
	import encryption from '@/utils/encryption.js'
	export default {
		data() {
			return {
				content: "", //使用条款详情
				content_tltle: '',
				content1: "", //隐私政策详情
				content_tltle1: '',
				dialogVisible1: false, //使用条款弹窗
				dialogVisible2: false, //
				screenHeight: '',
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					'Lang': 2, //语言代码,
					'ApiToken': '',
					'UserToken': '',
				},
				radio_list: [{
						id: 1,
						text: this.$t('m.userinfo_21'),
						Selected: true
					},
					{
						id: 2,
						text: this.$t('m.register_11'),
						Selected: false
					}
				],
				type: '1',
				dialogImageUrl: '', //本地路径
				dialogVisible: false,
				param: {
					email: '',
					password: '',
					password2: '',
					phone: '',
					email_code: '',
					company_name: '',
					company_number: '',
					company_img: ''
				},
				code_time: 60, //验证码保护器
				if_send: false, //是否发送了验证码

				other_id: 0,
				type: 1,
				// 获取判断是中英文
				lang: 0,
				// 是否邮箱
				is_yx:true,
			}
		},
		mounted() {
			this.other_id = this.$route.query.third_id
			this.type = this.$route.query.type||1
			console.log(this.$route.query)


			window.screenHeight = document.documentElement.clientHeight; //实时高度
			this.screenHeight = window.screenHeight - 80 - 25;
			let user_data = JSON.parse(localStorage.getItem('user_data'))
			if (!user_data) {
				this.headers.UserToken = ''
			} else {
				this.headers.UserToken = JSON.parse(localStorage.getItem('user_data')).token
			}
			this.headers.ApiToken = 200

			// 获取判断是中英文
			let lang = Cookies.get('lang')
			this.lang = lang
		},
		methods: {
			// 获取隐私条款和政策
			terms_of_use() {
				this.$api.terms_of_use().then((res) => {
					if (res.data.code == 1) {
						this.content = res.data.data.content
						this.content_tltle = res.data.data.title
					}
				})
			},
			privacy_policy() {
				this.$api.privacy_policy().then((res) => {
					if (res.data.code == 1) {
						this.content1 = res.data.data.content
						this.content_tltle1 = res.data.data.title
					}
				})
			},
			onError(e) {
				console.log(e)
			},
			//获取验证码
			getcode() {
				let that = this
				if (!this.param.email) {
					this.$message.warning(this.$t('m.register_08'))
				} else {
					let param = {
						email: this.param.email
					}
					let sing = encryption.getSing(param)

					this.$api.reg_send(param, sing).then((res) => {
						if (res.data.code == 1) {
							this.$message.success(this.$t('m.register_12'))
							this.if_send = true
							clearInterval(that.code_time);
							let timer = setInterval(() => {
								that.code_time--;
								if (that.code_time <= 0) {
									clearInterval(timer);
									that.if_send = false;
								}
							}, 1000);
						}
					})
				}
			},
			//获取验证码
			getcode_mobile() {
				let that = this
				if (!this.param.mobile) {
					this.$message.warning(this.$t('m.register_088'))
				} else {
					let param = {
						mobile: this.param.mobile
					}
					let sing = encryption.getSing(param)
					this.$api.reg_send2(param, sing).then((res) => {
						if (res.data.code == 1) {
							this.$message.success(this.$t('m.register_12'))
							this.if_send = true
							clearInterval(that.code_time);
							let timer = setInterval(() => {
								that.code_time--;
								if (that.code_time <= 0) {
									clearInterval(timer);
									that.if_send = false;
								}
							}, 1000);
						}
					})
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			onSuccess(e) {
				console.log('上传成功')
				console.log(e)
			},
			handlePictureCardPreview(file) {
				this.dialogVisible = true;
			},
			changeUploadCoverImg(event) {

			},
			updatarequest(e) {
				console.log(e.file)
				var files = event.target.files[0]
				let param = new FormData()
				param.append("file", files)
				console.log(param)
				this.$api.upload_business_license(param).then((res) => {
					console.log(1111)
					this.param.company_img = res.data.data.file_path || ''
				})
			},
			chang_radio(index) {
				this.radio_list.forEach(item => {
					item.Selected = false
				});
				this.radio_list[index].Selected = true
				this.type = this.radio_list[index].id
			},
			login() {
				this.$router.push({
					path: '/account/login'
				})
			},
			return_() {
				this.$router.push({
					path: '/'
				})
			},
			confirm() {
				let param = this.param
				param.type = this.type
				
				if (this.other_id) {
					if (this.type == 1) {
						param.facebook_id = this.other_id
					}
					if (this.type == 2) {
						param.google_id = this.other_id
					}
					param.reg_type = 3
				}else{
					if(this.is_yx){
						param.reg_type = 1
					}else{
						param.reg_type = 2
						param.phone = param.mobile
					}
				}


				if (1) {
					
				// if (!param.email) {
				// 	this.$message.warning(this.$t('m.login_09'))
				// } else if (!param.email_code) {
				// 	this.$message.warning(this.$t('m.register_09'))
				// } else if (!param.password) {
				// 	this.$message.warning(this.$t('m.login_10'))
				// } else if (!param.password2) {
				// 	this.$message.warning(this.$t('m.register_10'))
				// } else if (param.password2 != param.password) {
				// 	this.$message.warning(this.$t('m.RetrievePWD_08'))
				// } else {
					if (this.type == 1) {
						if (1) {
						// if (!param.phone) {
						// 	this.$message.warning(this.$t('m.userinfo_27'))
						// } else {
							let sing = encryption.getSing(param)
							//个人注册
							this.$api.register(param, sing).then((res) => {
								if (res.data.code == 1) {
									console.log(res.data)
									this.$router.push({
										path: '/account/registerSuccess?pageType=' + 1 + '&&email=' + this
											.param.email
									})
								}
							})
						}
					}
					if (this.type == 2) {
						delete param.phone
						if (!param.company_name) {
							this.$message.warning(this.$t('m.userinfo_19'))
						} else if (!param.company_number) {
							this.$message.warning(this.$t('m.userinfo_20'))
						} else {
							//公司注册
							let sing = encryption.getSing(param)
							this.$api.register(param, sing).then((res) => {
								if (res.data.code == 1) {
									console.log(res.data)
									this.$router.push({
										path: '/account/registerSuccess?pageType=' + 1 + '&&email=' + this
											.param.email
									})
								}
							})
						}
					}
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.tiaokuan {
		height: 60vh;
		overflow: auto;
	}

	.show_title {
		font-size: 36px;
		margin-bottom: 20px;
	}


	.topkongbox {
		height: 15px;
	}

	.main {
		width: 100%;
		background-image: url(../../static/images/brand/login_bac.png);
		background-size: 100% 100%;
		border-top: 5px solid #ef5843;

		h1 {
			text-align: center;
			font-size: 40px;
		}

		.mainkongbox {
			width: 100%;
			height: 100px;
		}

		.zhuce {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 10px;
			font-size: 15px;
			font-weight: bold;
		}



		.loginbox1 {
			width: 550px !important;

			.inp_text {
				min-width: 220px !important;
			}
		}

		.loginbox {
			width: 450px;
			margin: 30px auto;

			.btnbox {

				margin-top: 30px;
				width: 100%;

				::v-deep .el-button {
					width: 370px;
					font-weight: bold;
					height: 52px;
					margin: auto;
					display: block;
					background-color: #ef5843 !important;
				}
			}

			.upload_item {
				margin-top: 20px;
				width: 100%;

				p {
					padding: 0 20px;
				}

				.upload_box {
					margin-top: 20px;
				}
			}

			.yyzhimg {
				width: 146px;
				height: 146px;
				border-radius: 8px;
				margin-right: 10px;
			}

			.boxn {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				line-height: normal;
				width: 144px;
				height: 144px;
				border: 1px dashed #aaa;
				border-radius: 8px;

				span {
					margin-top: 6px;
					color: #697185;
				}
			}

			.upimg {
				position: relative;
			}

			.iptimg {
				background: pink;
				width: 144px;
				height: 144px;
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				opacity: 0;
			}

			::v-deep .el-upload--picture-card {
				border: 1px solid #e9e9ea;
			}

			.inp_item {
				border-bottom: 1px solid #d0cece;
				display: flex;
				align-items: center;
				height: 60px;
				padding: 0 20px;
				width: 100%;

				.code_style {
					color: #ef5843;
				}

				.inp_text {
					width: 120px;
					font-weight: bold;
					font-size: 14px;
				}

				.btn {
					width: 85px;
					height: 30px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 14px;
					background-color: #FFF;
					color: #ef5843;
					border: 2px solid #ef5843;
					border-radius: 4px;
				}

				.yzm {
					width: 100px !important;
				}

				.inp_radio {
					display: flex;
					align-items: center;

					.radio {
						display: flex;
						align-items: center;

						img {
							width: 18px;
							height: 18px;
						}

						span {
							margin-left: 6px;
						}
					}

					.radio:last-child {
						margin-left: 30px;
					}
				}

				.inp_ {
					flex: 1;
					display: flex;

					input {
						width: 100%;
						border: 0 !important;
						margin-left: 10px;
						height: 56px;
						background-color: transparent;
						outline: none;
					}
				}
			}
		}

		.agreement {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			margin-top: 30px;
		}
	}

	.header {
		width: 100%;
		height: 90px;
		background-color: #FFF;
		display: flex;
		justify-content: space-between;
		padding: 0 145px;
		align-items: center;

		.logo {
			img {
				width: 90px;
				// height: 53.5px;
			}
		}

		.header_right {
			display: flex;
			align-items: center;

			img {
				width: 15px;
				height: 15px;
			}
		}
	}

	.gugestyle {
		border: 2px solid #4285f4;
		background-color: #4285f4;
	}

	.facebookstyle {
		border: 2px solid #3b5998;
		background-color: #3b5998;
	}

	.twitterstyle {
		border: 2px solid #000000;
		background-color: #fff;
		color: #000000 !important;
	}

	.border-right1 {
		border-right: 2px solid #4285f4;
	}

	.border-right2 {
		border-right: 2px solid #3b5998;
	}

	.border-right3 {
		border-right: 2px solid #000000;
	}

	.foot_kongbox {
		height: 30px;
	}
	
	
	
	
	
	// 宽度小于1200px
	@media screen and (max-width: 1200px){
		.header{
			height: 2.5rem;
			padding: 0 1rem;
			.logo{
				img{
					width: 2.275rem;
					height: auto;
					display: block;
				}
			}
		}
		.mainkongbox{
			height: 3rem!important;
		}
		.main{
			.loginbox{
				width: 100%!important;
				padding: 0 1rem;
			}
			.loginbox1{
				width: 100%!important;
				padding: 0 1rem;
			}
			
			.inp_item{
				flex-wrap: wrap;
				height: auto!important;
				padding: 1rem 0!important;
				.inp_text{
					width: 100%!important;
					padding-bottom: 1rem;
					padding-left: 10px;
				}
				input{
					height: auto!important;
					// margin-left: 0!important;
				}
			}
		}
		.loginbox{
			width: 100%!important;
			padding: 0 1rem;
		}
		.loginbox1{
			width: 100%!important;
			padding: 0 1rem;
		}
		.topkongbox{
			height: 0;
		}
		.agreement{
			padding: 1rem ;
			// padding-bottom: 4rem;
			display: block!important;
			.orange{
				display: inline-block;
			}
		}
		::v-deep .el-button {
			width: 100%!important;
			font-weight: bold;
			height: 52px;
			margin: auto;
			display: block;
			background-color: #ef5843 !important;
		}
		::v-deep .el-dialog {
			// background-color: #f6f7fa;
			width: 90%!important;
			margin-top: 10%!important;
		}
	}
</style>
